import { Routes, Route } from 'react-router-dom'

import Home from './pages/Home'
import Pricing from './pages/Pricing'
import Pipeline from './pages/Pipeline'
import PropertyDashboard from './pages/PropertyDashboard'
import Arv from './pages/Arv'
import ListingDetails from './pages/ListingDetails'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import PasswordUpdated from './pages/PasswordUpdated'
import Payment from './pages/Payment'
import PaymentSuccess from './pages/PaymentSuccess'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import ProtectedRoute from './components/ProtectedRoute'
import ScrollToTop from './components/ScrollToTop'
import ExpiredModal from './features/subscription/ExpiredModal'

function App() {
  return (
    <>
    <ScrollToTop />
    <ExpiredModal />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/pipeline" element={
        <ProtectedRoute><Pipeline /></ProtectedRoute>
      } />
      <Route path="/property/:id" element={
        <ProtectedRoute><PropertyDashboard /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv" element={
        <ProtectedRoute><Arv /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv/listing/:listingIndex" element={
        <ProtectedRoute><ListingDetails /></ProtectedRoute>
      } />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/password-updated" element={<PasswordUpdated />} />
      <Route path="/payment" element={
        <ProtectedRoute><Payment /></ProtectedRoute>
      } />
      <Route path="/payment/success" element={
        <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
      } />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
    </>
  )
}

export default App
